<template>
  <span v-if="showSelectStatus">
    <b-form-group
      label="Status"
    >
      <b-form-select
        v-model="status"
        :options="optionsStatus"
        trim
        @change="$emit('handleStatus', status)"
      />
    </b-form-group>
  </span>
</template>

<script>
export default {
  props: {
    showSelectStatus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      status: '',
      localDataLoad: false,
      optionsStatus: [{ value: '0', text: '🔴 Not Active' }, { value: '1', text: '🟢 Active' }],
    }
  },
  watch: {
    '$route.query.status': {
      immediate: true,
      handler(newVal) {
        this.status = newVal || null
      },
    },
  },
}
</script>
